export default __webpack_public_path__ + "media/bd852474cda888daf2cca976618fcfee57d4496930fb8bcdbc752b0d132819f4.svg";